import React from 'react';
import { connect } from 'react-redux';
import { CheckBox } from 'components/tt-forms/common';
import ThongTinCaNhan from './ThongTinCaNhan.jsx';
import ThongTinLuatSu from './ThongTinLuatSu.jsx';
import {validatable} from 'components/utils';

class ThongTinUyQuyen extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      flagLuatSu: false,
    }
  }

  onChangeCheckBox(name, e) {
    this.state[name] = !this.state[name];
    this.setState({...this.state});
    this.props.onChange(this.state);
  }

  onChangeLuatSu(data, isInit) {
    let newState = {
      ...this.state,
      luatSu: data
    }
    this.setState({...newState});
    this.props.onChange(newState, isInit);
  }

  getThongTinCaNhan(thongTinCaNhan) {
    this.props.dispatch({
      type: 'CAP_NHAT_THONG_TIN_CA_NHAN',
      data: thongTinCaNhan,
      index: -1
    });
  }

  handleRemove(data) {
    this.props.onRemove('CONG_DAN', data);
  }

  componentDidMount() {
    let state = this.state;
    if (this.props.data.donId || this.props.data.donCuId && this.props.data.nguoiDuocUyQuyen) {
      if (this.props.data && this.props.data.nguoiDuocUyQuyen && this.props.data.nguoiDuocUyQuyen.luatSu) {
        state.flagLuatSu = this.props.data.nguoiDuocUyQuyen.luatSu;
      }
      this.setState(state);
      this.props.onChange(this.state, true);
    }
  }

  render() {
    return (
      <div>
        <div className="title">
          <div className="rows">
            <div className="col-12">
              <h3>Thông tin người được ủy quyền</h3>
            </div>
          </div>
        </div>
        <ThongTinCaNhan
          index={-1}
          data={this.props.nguoiUyQuyen}
          onChange={this.getThongTinCaNhan.bind(this)}
          isRemoveable={false}
          handleRemove={this.handleRemove.bind(this)}
          bindValidator={this}
          uyQuyen={true}
        />
        <CheckBox
          ten="Luật sư"
          isChecked={this.state.flagLuatSu}
          onChange={this.onChangeCheckBox.bind(this, 'flagLuatSu')}
          componentFill={<ThongTinLuatSu isDonCu={this.props.isDonCu} onChange={this.onChangeLuatSu.bind(this)} bindValidator={this} data={this.props.data} onSave={this.props.onSave}/>} />
      </div>
    )
  }
}

ThongTinUyQuyen.defaultProps = {
  onSave: false
}

function bindStateToProps(state) {
  return {
    nguoiUyQuyen: state.formDataTiepCongDan.nguoiUyQuyen
  };
}

export default connect(bindStateToProps)(validatable(ThongTinUyQuyen));



// WEBPACK FOOTER //
// ./src/components/modules/reception/ThongTinUyQuyen.jsx